import type { ServiceLabel } from './types';

export const UK_SERVICES: readonly ServiceLabel[] = [
  { key: 'VAT Returns',         label: 'VAT Returns',           jurisdiction: 'UK' },
  { key: 'Confirmation Statements', label: 'Confirmation Statements', jurisdiction: 'UK' },
  { key: 'Companies House',     label: 'Companies House',       jurisdiction: 'UK' },
  { key: 'HMRC Filings',        label: 'HMRC Filings',          jurisdiction: 'UK' },
  { key: 'Payroll Runs',        label: 'Payroll Runs',          jurisdiction: 'UK' },
  { key: 'Pension Runs',        label: 'Pension Runs',          jurisdiction: 'UK' },
  { key: 'Self Assessments',    label: 'Self Assessments',      jurisdiction: 'UK' },
  { key: 'Bookkeeping',         label: 'Bookkeeping',           jurisdiction: 'UK' },
  { key: 'Companies House Filing', label: 'Companies House filing', jurisdiction: 'UK' },
  { key: 'HMRC Filing',         label: 'HMRC Filing',           jurisdiction: 'UK' },
  { key: 'Payroll',             label: 'Payroll',               jurisdiction: 'UK' },
  { key: 'Pension',             label: 'Pension',               jurisdiction: 'UK' },
  { key: 'VAT',                 label: 'VAT',                   jurisdiction: 'UK' },
  { key: 'Other',               label: 'Other',                 jurisdiction: 'UK' },
] as const;